import styled, { css } from 'styled-components';
import { mq, containerWidth, gridGutter } from '../../styles/grid';

/**
 * @typedef {Object} ContainerProps
 * @property {boolean} [isJobSearch]
 */

/** @type {import('styled-components').StyledComponent<'div', any, ContainerProps, never>} */
const Container = styled.div`
  position: relative;
  margin: 0 auto;
  width: 100%;
  max-width: ${containerWidth.xl}px;
  @media (${mq.lgDown}) {
    padding: 0 ${gridGutter}px;
    ${({ isJobSearch }) =>
      isJobSearch
        ? css`
            max-width: calc(100% - 100px);
          `
        : css`
            max-width: ${containerWidth.lg}px;
          `};
  }

  @media (${mq.mdDown}) {
    max-width: ${containerWidth.md}px;
  }

  @media (${mq.sm}) {
    max-width: calc(100% - 100px);
  }
`;

export default Container;
